import { AnyAction } from 'redux'
import { produce } from 'immer'
import { PaginateRequest, PaginateResponse } from '../../services/api.service'
import { PalletData } from '../../apis/pallet.api'
import palletService from '../../services/pallet.service'
import { ActionName } from '../../components/Actions'

interface State extends PaginateRequest {
  result: PaginateResponse<PalletData[]>
  search: string
}

const initialState: State = {
  result: {
    data: [],
    total: 0,
    from: null,
    to: null,
    currentPage: 0,
    lastPage: 0
  },
  page: 1,
  limit: 25,
  search: ''
}

export const actions = {
  replaceResult: 'receivings/replaceResult',
  replaceResultData: 'receivings/replaceResultData',
  replacePage: 'receivings/replacePage',
  replaceLimit: 'receivings/replaceLimit',
  replaceSearch: 'receivings/replaceSearch'
}

export function replaceResult (result: State['result']) {
  return { type: actions.replaceResult, result }
}

export function replaceResultData (data: State['result']['data']) {
  return { type: actions.replaceResultData, data }
}

export function replacePage (page: number) {
  return { type: actions.replacePage, page }
}

export function replaceLimit (limit: number) {
  return { type: actions.replaceLimit, limit }
}

export function replaceSearch (search: string) {
  return { type: actions.replaceSearch, search }
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.replaceResult: {
      const actions: ActionName[] = [
        'view', 'history', 'print', 'rollback', 'delete'
      ]
      return produce(state, draft => {
        draft.result = action.result
        draft.result.data = palletService.tableHorizontalData(action.result.data, actions)
      })
    }
    case actions.replaceResultData:
      return produce(state, draft => {
        draft.result.data = action.data
      })
    case actions.replacePage:
      return produce(state, draft => {
        draft.page = action.page
      })
    case actions.replaceLimit:
      return produce(state, draft => {
        draft.limit = action.limit
      })
    case actions.replaceSearch:
      return produce(state, draft => {
        draft.search = action.search
      })
    default:
      return state
  }
}
